<template>
  <div>
    <div class="row mt-2">
      <div class="col-md-12 mb-5">
        <h2>Template panel</h2>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="card">
          <div class="card-header">
            <h3>Email template</h3>
          </div>
          <div class="card-body">
            <ValidationObserver ref="emailForm">
              <validation-provider rules="required" v-slot="{errors,classes }">
                <div class="form-group">
                  <label>From Name</label>
                  <input type="text" name="email_from_name" id="email_from_name" class="form-control"
                         placeholder="John Due" v-model="email_template.from_name" :class="classes">
                  <div class="invalid-feedback">{{ errors[0] }}</div>
                </div>
              </validation-provider>
              <validation-provider rules="email|required" v-slot="{errors,classes }">
                <div class="form-group">
                  <label>From Email</label>
                  <input type="email" name="email_from_email" id="email_from_email" class="form-control"
                         placeholder="email@demo.com" v-model="email_template.from_email" :class="classes">
                  <div class="invalid-feedback">{{ errors[0] }}</div>
                </div>
              </validation-provider>
              <validation-provider rules="required" v-slot="{errors,classes }">
                <div class="form-group">
                  <label>Email subject</label>
                  <input type="text" name="email_subject" id="email_subject" class="form-control"
                         placeholder="email_subject" v-model="email_template.subject" :class="classes">
                  <div class="invalid-feedback">{{ errors[0] }}</div>
                </div>
              </validation-provider>
              <validation-provider rules="required" v-slot="{errors,classes }">
                <div class="form-group">
                  <label>Email body</label>
                  <textarea name="email_body" id="email_body" class="form-control"
                            placeholder="email_body" v-model="email_template.body" :class="classes"></textarea>
                  <div class="invalid-feedback">{{ errors[0] }}</div>
                </div>
              </validation-provider>
              <div>
                <button type="button" class="btn btn-success" @click="storeEmailTemplate()">Save</button>
              </div>
            </ValidationObserver>
          </div>
        </div>
      </div>
      <div class="col-md-6" v-if="false">
        <div class="card">
          <div class="card-header">
            <h3>Sms template</h3>
          </div>
          <div class="card-body">
            <ValidationObserver ref="smsForm">
              <validation-provider rules="required" v-slot="{errors,classes }">
                <div class="form-group">
                  <label>Email body</label>
                  <textarea name="email_body" id="sms_body" class="form-control"
                            placeholder="sms body" v-model="smsTemplate.body" :class="classes"></textarea>
                  <div class="invalid-feedback">{{ errors[0] }}</div>
                </div>
              </validation-provider>
              <div>
                <button type="button" class="btn btn-success" @click="storeSmsTemplate()">Save</button>
              </div>
            </ValidationObserver>
          </div>
        </div>
      </div>
    </div>
    <div>
      <b-modal v-model="modalShow" id="modalPopover" size="sm" ok-only>
        Template saved successfully
      </b-modal>
    </div>
  </div>
</template>

<script>
import ApiService from "../../../libs/ApiService";
import {BModal, VBModal} from 'bootstrap-vue'

export default {
  name: "Templates",
   components: {
      BModal,
    },
  data() {
    return {
        modalShow: false,
      email_template: {
        subject: "",
        body: "",
        from_name:"",
        from_email:"",
      },
      sms_template: {
        body: "you must set {LINK_URL} place holder in the SMS"
      }
    }
  },
  methods: {
    async storeEmailTemplate() {
      //trigger validation
      let isValid = await this.$refs.emailForm.validate();
      if (!isValid) {
        return;
      }
      try{
         let res = await ApiService.post("/private/templates/storeEmailTemplate", this.email_template);
         // we store the template on the user store, so refresh it..
         await this.$store.dispatch('me/loadFromServer');
        this.modalShow=true;
      }
      catch(e){
        console.error(e.message);
      }
    },
    async storeSmsTemplate() {
      //trigger validation
      if (!await this.$refs.smsForm.validate()) {
        return;
      }
      if (!this.sms_template.body.includes("{LINK_URL}")) {
        alert("you must add {LINK_URL} to the SMS");
      }
      alert("Permissions deied")
    }
  },
  created() {
    //set the sms template
    let sms_template = this.$store.state.me.user.sms_template || {};
    this.sms_template = Object.assign(this.sms_template, sms_template);
    //set the sms template
    let email_template = this.$store.state.me.user.email_template || {};
    this.email_template = Object.assign(this.email_template, email_template);
  }
}
</script>

<style scoped>

</style>
